import OnboardingCompleted from "@/components/Onboarding/OnboardingCompleted/OnboardingCompleted";

function OnboardingCompletedPage() {
  return <OnboardingCompleted />;
}

export default OnboardingCompletedPage;
